/**
 * ENVOYER UNE LECTURE AU SUIVI DE LA POSTE, À LA MAIN, SANS PERDRE SON DOSSIER.
 *
 * La lecture décide seule de la destination quand le type ressemble à du
 * courrier (AR, recommandé…), et le dossier de la correspondance devient alors
 * celui du courrier. Mais quand la ressemblance rate — une convocation, une
 * lettre de la préfecture — et qu'on bascule soi-même sur « Suivi de la
 * Poste », le dossier restait vide : la lecture l'avait trouvé, la carte le
 * redemandait, et sans lui « Valider » ne s'allume pas.
 *
 * Le dossier suit donc la bascule — celui de la correspondance encore choisie,
 * ou celui choisi à la main. Un dossier qu'on a écarté (« changer ») ne suit
 * pas : il n'a plus de nom, et un courrier classé dans le mauvais dossier est
 * pire qu'une case vide.
 */
export interface PosteSource {
  /** Le dossier de la correspondance, ou celui choisi à la main. */
  dossierId: string;
  /** Le nom du dossier choisi à la main (création d'une demande). */
  dossierName: string;
  /** Le nom du dossier de la correspondance ; vidé quand on l'écarte. */
  targetDossierName?: string;
  posteDossierId?: string;
  posteDossierName?: string;
}

export function sendToPoste(item: PosteSource): {
  posteMode: true; createMode: false; posteDossierId?: string; posteDossierName?: string;
} {
  if (item.posteDossierId) return { posteMode: true, createMode: false };
  const name = item.targetDossierName || item.dossierName;
  return item.dossierId && name
    ? { posteMode: true, createMode: false, posteDossierId: item.dossierId, posteDossierName: name }
    : { posteMode: true, createMode: false };
}
